export default "__VITE_ASSET__dmsM4gX2__"